import React from "react";
import Icon from "../Icon";
import { IToastIconProps } from "./types";
import { StyledIconWrapper } from "./styled";

const ToastCloseIcon: React.FC<IToastIconProps> = ({ closeToast }) => {
  return (
    <StyledIconWrapper role="button" tabIndex={0} onClick={closeToast}>
      <Icon name="close" size="18px" isInline color="graySolid3" />
    </StyledIconWrapper>
  );
};

export default ToastCloseIcon;
